import { updateMicroStepEvent } from '@cof/refi-web-sdk/dist/utils/update-progress-bar';
import { REFI_VEHICLE_LOAN_CONST } from '../../shared/constants/app.constants.js';
import { ApplicationService } from '../../services/application.service.js';

export const stateChangedEvent = (
  element,
  currentSteps,
  currentStepIndex,
  forceUrlUpdate = false
) => {
  if (currentStepIndex !== 0) {
    updateMicroStepEvent(currentSteps[currentStepIndex - 1]);
  } else {
    const microStepsList = ApplicationService.isUpfrontOffers
      ? REFI_VEHICLE_LOAN_CONST.UFO_PROGRESS_BAR_MICRO_STEPS.microStepsList
      : // eslint-disable-next-line no-constant-condition
      ApplicationService.isIconicAndToggledOn
      ? REFI_VEHICLE_LOAN_CONST.ICONIC_PROGRESS_BAR_MICRO_STEPS.microStepsList
      : REFI_VEHICLE_LOAN_CONST.PROGRESS_BAR_MICRO_STEPS.microStepsList;
    const startingMicroStepIndex = microStepsList.findIndex(
      (step) => step === currentSteps[currentStepIndex]
    );
    updateMicroStepEvent(
      startingMicroStepIndex === 0
        ? ''
        : microStepsList[startingMicroStepIndex - 1]
    );
  }
  element.dispatchEvent(
    new CustomEvent('host-app-event', {
      bubbles: true,
      composed: true,
      detail: {
        actionName: 'state-changed',
        data: { state: currentSteps[currentStepIndex] },
        forceUrlUpdate,
      },
    })
  );
};

export const showBackButtonEvent = (element, showBackButton = false) => {
  element.dispatchEvent(
    new CustomEvent('host-app-event', {
      bubbles: true,
      composed: true,
      detail: {
        actionName: 'show-back-button',
        showBackButton,
      },
    })
  );
};
